import $ from 'jquery';
import { onTransitionEnd } from '../../helpers/ontransitionend'; 

/**
* Renders alert snippet
*/
export default class AlertSnippet {
    /**
     * @param options - Alert
     */
    constructor($alert, options = {}) {
        this.options = $.extend(true, {
            classes: {
                hidden: 'alert--hidden',
                close: 'alert__close',
            },
        }, options);

        if (!$alert) {
            return;
        }

        this.$alert = $alert;
        this.$close = this.$alert.querySelector('.' + this.options.classes.close);

        this.init();
    }

    init() {
        this.closeAlert();
    }

    closeAlert() {
        const handler = () => {
            this.$alert.classList.add(this.options.classes.hidden);
            onTransitionEnd(this.$alert).then(() => {
                this.$alert.remove();
            });
        }

        this.$close.addEventListener('click', handler);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/alerts/alert-snippet.js